import withSharedStyles from "../theme/Shared.style";

const withCustomStyles = withSharedStyles(theme => {
  const { color, radius, fontSize } = theme.tokens;
  return {
    page: {
      ...theme.mixins.pageWide
    },
    // groups of sections rendered inside one lazy wrapper keep the 48px rhythm
    stack: {
      display: "flex",
      flexDirection: "column",
      gap: theme.layout.sectionGap,
      minWidth: 0,
      [theme.media.phone]: { gap: 36 }
    },
    appBanner: {
      display: "block",
      borderRadius: radius.card,
      overflow: "hidden",
      [theme.media.tabletUp]: { display: "none" }
    },
    memberBanner: {
      display: "block",
      borderRadius: radius.card,
      overflow: "hidden",
      width: "100%"
    },
    bannerImg: {
      display: "block",
      width: "100%",
      height: "auto"
    },
    allCategories: {
      display: "flex",
      flexDirection: "column",
      gap: 24
    },
    sectionTitle: {
      margin: 0,
      fontSize: fontSize.h2,
      fontWeight: 800,
      letterSpacing: "-0.01em",
      color: color.ink,
      [theme.media.phone]: { fontSize: fontSize.mobile.h2 }
    },
    srOnly: {
      position: "absolute",
      width: 1,
      height: 1,
      overflow: "hidden",
      clip: "rect(0 0 0 0)",
      whiteSpace: "nowrap",
      margin: 0
    }
  };
});

export default withCustomStyles;
